import { useActions, useGetters } from 'vuex-composition-helpers';
import { NAMESPACE as HOTEL_PAGE_EMPTY_SEARCH_STORE } from '@ve/components/hotel/emptySearch/common/store/hotelPageEmptySearchStore';
import {
 computed, ComputedRef, Ref, unref,
} from 'vue';
import { NAMESPACE as DATES_TABS_STORE_NAME } from '@ve/components/hotel/datesTabs/common/store/DatesTabsStore';
import moment from 'moment';
import { IDatesTabsStore } from '@ve/components/hotel/datesTabs/common/store/types/types';

type THotelPageEmptySearchStoreUseGetters = {
    isSearchDepartureCityFromRegion: Ref<boolean>,
    isProductsOfSelectedAndOtherDatesAreEmpty: Ref<boolean>,
    isProductsOfSelectedDateAreEmptyButExistsOnOtherDates: Ref<boolean>,
    isSyncProductsExistsOnSelectedDate: Ref<boolean>,
    isSyncProductsOnSelectedDateIncludesTourProducts: Ref<boolean>,
    selectedDateText: Ref<string>,
    otherDatesAvailableInInterval: Ref<Array<string>>
    isShouldRenderAnotherProductsBlock: Ref<boolean>,
    isShouldRenderEmptySearchBlock: Ref<boolean>,
}

interface IUseEmptySearchReturn extends THotelPageEmptySearchStoreUseGetters {
    upperText: ComputedRef<string>,
    clickAnotherSpecificDateHandler: (date: string) => void,
}

export default (): IUseEmptySearchReturn => {
    const {
        selectDateManually,
    } = useActions<IDatesTabsStore['actions']>(DATES_TABS_STORE_NAME, ['selectDateManually']);

    const {
        isSearchDepartureCityFromRegion,
        isProductsOfSelectedAndOtherDatesAreEmpty,
        isProductsOfSelectedDateAreEmptyButExistsOnOtherDates,
        isSyncProductsExistsOnSelectedDate,
        isSyncProductsOnSelectedDateIncludesTourProducts,
        selectedDateText,
        otherDatesAvailableInInterval,
        isShouldRenderAnotherProductsBlock,
        isShouldRenderEmptySearchBlock,
    } = useGetters<THotelPageEmptySearchStoreUseGetters>(HOTEL_PAGE_EMPTY_SEARCH_STORE, ['isSearchDepartureCityFromRegion', 'isProductsOfSelectedAndOtherDatesAreEmpty', 'isProductsOfSelectedDateAreEmptyButExistsOnOtherDates', 'isSyncProductsExistsOnSelectedDate', 'isSyncProductsOnSelectedDateIncludesTourProducts', 'selectedDateText', 'otherDatesAvailableInInterval', 'isShouldRenderAnotherProductsBlock', 'isShouldRenderEmptySearchBlock']);

    const upperText = computed((): string => {
        if (unref(isSyncProductsExistsOnSelectedDate) && !unref(isSyncProductsOnSelectedDateIncludesTourProducts)) {
            return `На ${unref(selectedDateText)} нет туров с авиаперелётами по вашим критериям`;
        }
        return `На ${unref(selectedDateText)} нет предложений по вашим критериям`;
    });

    const clickAnotherSpecificDateHandler = (date: string): void => {
        const formattedDate = moment(date, 'DD MMMM').format('YYYY-MM-DD');
        selectDateManually(formattedDate);
    };

    return {
        isSearchDepartureCityFromRegion,
        isProductsOfSelectedAndOtherDatesAreEmpty,
        isProductsOfSelectedDateAreEmptyButExistsOnOtherDates,
        isSyncProductsExistsOnSelectedDate,
        isSyncProductsOnSelectedDateIncludesTourProducts,
        selectedDateText,
        otherDatesAvailableInInterval,
        isShouldRenderAnotherProductsBlock,
        isShouldRenderEmptySearchBlock,
        upperText,
        clickAnotherSpecificDateHandler,
    };
};